import React from "react";
import { Alert, Box, Button } from "@mui/material";
import MessageThread from "./MessageThread";
import ChatLayout from "./ChatLayout";
import ChatEmptyStateV2 from "./ChatEmptyStateV2";
import ProductChatComposer from "./ProductChatComposer";
import ChatLibraryView from "./ChatLibraryView";
import { CHAT_MAIN_SX, CHAT_MODERN_CANVAS_SX, THREAD_WRAPPER_STYLE } from "./chatStyles";
import { CHAT_V2_INPUT_PLACEHOLDER } from "./chatV2Constants";
import ChatActionConfirmDialog from "./ChatActionConfirmDialog";
import ExportReviewDialog from "../../components/ExportReviewDialog";
import { CHAT_CONNECTION_ERROR_MESSAGE } from "./chatConnectionError";

function ChatPageView({
  navigationData, layoutSidebarProps, handleStartNewChatFromShell, handleOpenLibrary,
  showLibrary, chatBusy, sessionId, handleOpenSessionFromLibrary,
  restoreError, connectionRetry, messages, processingId, exportingId,
  handleExportCompanies, artifactActionInFlight, handleRunArtifactAction, handleSendSuggestion,
  processing, restoring, handleSend, composerActions,
  composerActionInFlightKey, handleRunComposerAction, composerPrefill, exportReview,
  exportDialogError, setExportReview, setExportDialogError, confirmExportCompanies, actionConfirmation
}) {
  return (
    <ChatLayout
      navigationData={navigationData}
      sidebarProps={layoutSidebarProps}
      onNewChat={handleStartNewChatFromShell}
      onOpenLibrary={handleOpenLibrary}
      activeView={showLibrary ? 'library' : 'chat'}
      chatNavigationDisabled={chatBusy}
      chatChromeVersion="v3"
    >
      {showLibrary ? (
        <ChatLibraryView
          sessions={navigationData.sessions}
          loading={navigationData.sessionsLoading}
          error={navigationData.sessionsError}
          selectedSessionId={sessionId}
          onRetry={navigationData.refreshSessions}
          onNewChat={handleStartNewChatFromShell}
          onOpenSession={handleOpenSessionFromLibrary}
        />
      ) : (
      <Box sx={CHAT_MODERN_CANVAS_SX}>
        {restoreError || connectionRetry ? (
          <Alert
            severity="error"
            sx={{ m: 2, mb: 0 }}
            action={connectionRetry ? (
              <Button color="inherit" size="small" onClick={connectionRetry} disabled={processing || restoring}>
                Retry
              </Button>
            ) : undefined}
          >
            {restoreError || CHAT_CONNECTION_ERROR_MESSAGE}
          </Alert>
        ) : null}
        <Box sx={CHAT_MAIN_SX}>
          {messages.length > 0 ? (
            <>
              <Box style={THREAD_WRAPPER_STYLE}>
                <MessageThread
                  variant="modern"
                  messages={messages}
                  conversationId={sessionId || 'new-chat'}
                  busy={chatBusy}
                  streamingId={processingId}
                  exportingId={exportingId}
                  onExportCompanies={handleExportCompanies}
                  artifactActionInFlight={artifactActionInFlight}
                  onRunArtifactAction={handleRunArtifactAction}
                  onSendSuggestion={handleSendSuggestion}
                  onSelectClarificationOption={handleSend}
                  suggestionsDisabled={processing || restoring}
                />
              </Box>
              <ProductChatComposer
                layout="docked"
                onSend={handleSend}
                disabled={processing || restoring}
                placeholder={CHAT_V2_INPUT_PLACEHOLDER}
                composerActions={composerActions}
                actionInFlightKey={composerActionInFlightKey}
                onRunComposerAction={handleRunComposerAction}
                prefill={composerPrefill}
                showSuggestions={false}
              />
            </>
          ) : (
            <ChatEmptyStateV2 onSend={handleSend} disabled={processing || restoring} />
          )}
        </Box>
      </Box>
      )}
      <ChatActionConfirmDialog {...actionConfirmation} />
      <ExportReviewDialog
        open={Boolean(exportReview)}
        review={exportReview?.model}
        busy={Boolean(exportingId)}
        error={exportDialogError}
        onCancel={() => {
          setExportReview(null);
          setExportDialogError(null);
        }}
        onConfirm={confirmExportCompanies}
      />
    </ChatLayout>
  );
}

export { ChatPageView };
